var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 20,
    viewBox: "0 0 25 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 2.25L9.885 8.015L9.8875 8.0175C10.735 8.63875 11.1587 8.95 11.6237 9.07C12.0345 9.17628 12.4655 9.17628 12.8763 9.07C13.3413 8.95 13.7662 8.63875 14.6162 8.015C14.6162 8.015 19.5125 4.2575 22.25 2.25M1 14.5V5C1 3.6 1 2.9 1.2725 2.365C1.5125 1.89375 1.89375 1.5125 2.365 1.2725C2.9 1 3.6 1 5 1H19.5C20.9 1 21.6 1 22.1337 1.2725C22.605 1.5125 22.9875 1.89375 23.2275 2.365C23.5 2.89875 23.5 3.59875 23.5 4.99625V14.505C23.5 15.9025 23.5 16.6 23.2275 17.135C22.9875 17.6056 22.6046 17.988 22.1337 18.2275C21.6 18.5 20.9012 18.5 19.5037 18.5H4.99625C3.59875 18.5 2.89875 18.5 2.365 18.2275C1.89462 17.9878 1.51218 17.6054 1.2725 17.135C1 16.6 1 15.9 1 14.5Z",
    stroke: "#EDEDED",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.bbc0e6748db1d3f43d741239f8208a53.svg";
export { ForwardRef as ReactComponent };